import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { OneLivEducationalBackgroundForm } from "@/components/oneliv/oneliv-educational-background-form";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";

import type { JSX } from "react";

const GetOneLivUserEducationalBackground = graphql(`
  query GetOneLivUserEducationalBackground {
    ...OneLivEducationalBackgroundFormFragment
  }
`);

const oneLivEducationalBackgroundPageSearchSchema = z.object({
  action: z.string().optional().catch(""),
});

const OneLivEducationalBackground = (): JSX.Element => {
  const query = useGraphQL(GetOneLivUserEducationalBackground);

  const { data } = query;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Formações" align="center" />
      </HeaderRoot>

      <Page>
        <AsyncDataWrapper {...query}>
          {data ? <OneLivEducationalBackgroundForm data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/oneliv/educational-background")({
  component: OneLivEducationalBackground,
  validateSearch: oneLivEducationalBackgroundPageSearchSchema,
});
